var _ellipse, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.011,
    cy: 124.919,
    rx: 106,
    ry: 108.5,
    transform: "rotate(-3 118.011 124.919)",
    fill: "url(#paint0_linear_28_419)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.917 232.42C198.241 229.363 242.98 178.374 239.844 118.534C236.708 58.6929 186.884 12.6603 128.56 15.7169C70.2361 18.7736 25.4975 69.762 28.6336 129.603C31.7697 189.444 81.593 235.476 139.917 232.42Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.432 138.144C117.811 138.963 104.596 126.754 103.756 110.727C102.916 94.6997 114.783 81.1757 130.403 80.3571C146.024 79.5384 159.239 91.7479 160.079 107.775C160.919 123.802 149.053 137.326 133.432 138.144ZM129.646 65.9102C152.967 64.688 172.906 83.1094 174.16 107.037C175.414 130.965 157.51 151.369 134.189 152.591C110.868 153.813 90.9297 135.392 89.6757 111.465C88.4217 87.537 106.325 67.1324 129.646 65.9102ZM174.569 152.739C177.583 155.523 177.82 160.038 175.102 162.896L148.455 193.266C145.748 196.35 141.348 196.581 138.554 193.785C135.54 191 135.304 186.486 138.022 183.627L164.669 153.257C167.155 150.185 171.775 149.942 174.569 152.739ZM186.568 70.1704C186.781 74.2335 183.866 77.5552 179.906 77.7627C175.946 77.9703 172.7 74.9715 172.487 70.9083C172.274 66.8451 175.189 63.5234 179.149 63.3159C182.889 63.1199 186.355 66.1072 186.568 70.1704Z",
    fill: "url(#paint1_linear_28_419)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M234.851 118.795C237.848 175.989 195.001 224.526 139.406 227.439C83.8105 230.353 36.1248 186.561 33.1274 129.367C30.13 72.1737 72.977 23.6367 128.572 20.7231C184.167 17.8095 231.853 61.6018 234.851 118.795Z",
    stroke: "url(#paint2_linear_28_419)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_419",
    x1: 118.011,
    y1: 16.4187,
    x2: 118.011,
    y2: 233.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02CCE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A51D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_419",
    x1: 102.457,
    y1: 75.3208,
    x2: 170.529,
    y2: 174.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4DD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_419",
    x1: 128.311,
    y1: 15.73,
    x2: 139.667,
    y2: 232.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2952D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CAE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrt);
export default __webpack_public_path__ + "static/media/grt.1ca730ec84aaa80f577e87669db41a48.svg";
export { ForwardRef as ReactComponent };